<script setup>
/* global axios */
// Meta katalogu sekmesi.
//
// Bu ekran urun LISTELEMEZ. Meta'daki urunler baglandigi anda "Ürünler"
// sekmesine iner ve orada Facebook ikonuyla isaretlenir; ayri bir "Meta
// urunleri" listesi saticiyi iki liste arasinda gezdirmek olurdu ve hangisinin
// dogru oldugu belirsiz kalirdi. Burasi yalnizca BAGLANTIYI yonetir:
// hangi isletme, hangi katalog, en son ne zaman esitlendi.
//
// Meta hesabi bagli degilse HIC istek atmiyoruz: jetonsuz her cagri hata ile
// doner ve kullaniciya anlamsiz bir mesaj gosterir.
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const uc = computed(() => `/api/v1/accounts/${route.params.accountId}/katalog`);

const yukleniyor = ref(true);
const hata = ref('');
const hataKodu = ref('');
const bagli = ref(true);
const kataloglar = ref([]);
const secili = ref(null);
const seciliId = ref('');

const baglaniyor = ref(false);
const disaAktariliyor = ref(false);
const sonuc = ref('');
// Ice aktarilamayan urunler ve Meta'ya gonderilemeyen (zorunlu alani eksik)
// urunler. "3 urun aktarildi" demek yetmiyor; kullanici hangisinin neden
// disarida kaldigini bilmeden duzeltemez.
const ayrintilar = ref([]);
const atlananlar = ref([]);
const atlananIce = ref(0);

const mesgul = computed(() => baglaniyor.value || disaAktariliyor.value);

const seciliKatalog = computed(
  () => kataloglar.value.find(k => String(k.id) === String(seciliId.value)) || null
);

// Commerce Manager saticinin katalogunu Meta tarafinda actigi yer. Dogrudan
// isletmeye giden bir baglanti vermek, "kataloğum nerede" sorusunu ortadan
// kaldiriyor.
const commerceAdresi = computed(() => {
  const isletmeId = secili.value?.isletme_id || seciliKatalog.value?.isletme_id;
  return isletmeId
    ? `https://www.facebook.com/commerce_manager?business_id=${isletmeId}`
    : 'https://www.facebook.com/commerce_manager';
});

const izinHatasi = computed(() => hataKodu.value === 'izin');

const hataYaz = e => {
  hata.value = e.response?.data?.error || e.message;
  hataKodu.value = e.response?.data?.kod || '';
};

const zamanMetni = deger => {
  if (!deger) return '';
  const tarih = new Date(deger);
  if (Number.isNaN(tarih.getTime())) return String(deger);
  return tarih.toLocaleString('tr-TR', { dateStyle: 'medium', timeStyle: 'short' });
};

const kataloglariYukle = async () => {
  yukleniyor.value = true;
  hata.value = '';
  hataKodu.value = '';
  try {
    const { data } = await axios.get(`${uc.value}/meta/kataloglar`);
    bagli.value = data.bagli !== false;
    kataloglar.value = data.kataloglar || [];
    secili.value = data.secili || null;

    // Secim kutusu: bagli katalog varsa onu, yoksa tek katalogu sec.
    if (secili.value) seciliId.value = String(secili.value.id);
    else if (kataloglar.value.length === 1) seciliId.value = String(kataloglar.value[0].id);
  } catch (e) {
    hataYaz(e);
  } finally {
    yukleniyor.value = false;
  }
};

// Baglama ayni zamanda ICE AKTARIR: kullanici katalogu sectikten sonra ayrica
// "ice aktar" demek zorunda kalmasin, bagladigi anda urunlerini gormeyi
// bekliyor.
const bagla = async () => {
  if (!seciliId.value || mesgul.value) return;

  baglaniyor.value = true;
  hata.value = '';
  hataKodu.value = '';
  sonuc.value = '';
  try {
    const { data } = await axios.post(`${uc.value}/meta/baglan`, {
      katalog_id: seciliId.value,
    });
    secili.value = data.katalog || null;
    ayrintilar.value = data.hatalar || [];
    // Yerelde degistirilip henuz gonderilmemis urunler EZILMEZ, atlanir.
    // Kullaniciya kac tanesinin atlandigini soylemezsek "ice aktardim ama
    // bir sey degismedi" diye dusunur.
    atlananIce.value = data.atlanan || 0;
    sonuc.value = t('KATALOG.META.ICE_AKTAR_SONUC', {
      eklenen: data.eklenen || 0,
      guncellenen: data.guncellenen || 0,
    });
    useAlert(sonuc.value);
    await kataloglariYukle();
  } catch (e) {
    hataYaz(e);
  } finally {
    baglaniyor.value = false;
  }
};

const baglantiyiKaldir = async () => {
  // Urunler silinmez, yalnizca baglanti kopar; onay metninde bunu yaziyoruz ki
  // kullanici "urunlerim gidecek mi" diye tereddut etmesin.
  if (!window.confirm(t('KATALOG.META.KALDIR_ONAYI'))) return;

  baglaniyor.value = true;
  try {
    await axios.delete(`${uc.value}/meta/baglan`);
    secili.value = null;
    sonuc.value = '';
    useAlert(t('KATALOG.META.KALDIRILDI'));
    await kataloglariYukle();
  } catch (e) {
    hataYaz(e);
  } finally {
    baglaniyor.value = false;
  }
};

const disaAktar = async () => {
  if (!secili.value || mesgul.value) return;

  // Bu islem yayinda olan urunleri Meta katalogunda YAYINLAR, yani dogrudan
  // musteriye gorunur hale getirir. Geri almak elle temizlik gerektiriyor.
  if (!window.confirm(t('KATALOG.META.DISA_AKTAR_ONAYI', { katalog: secili.value.ad }))) return;

  disaAktariliyor.value = true;
  hata.value = '';
  hataKodu.value = '';
  sonuc.value = '';
  try {
    const { data } = await axios.post(`${uc.value}/meta/disa-aktar`, {
      katalog_id: secili.value.id,
    });
    atlananlar.value = data.atlananlar || [];
    sonuc.value = t('KATALOG.META.DISA_AKTAR_SONUC', { gonderilen: data.gonderilen || 0 });
    useAlert(sonuc.value);
  } catch (e) {
    // Sunucu "gonderilebilecek urun yok" derken atlananlari da yolluyor;
    // kullaniciya hangi alanin eksik oldugunu gostermek icin saklariz.
    atlananlar.value = e.response?.data?.atlananlar || [];
    hataYaz(e);
  } finally {
    disaAktariliyor.value = false;
  }
};

const urunlereGit = () =>
  router.push({ name: 'katalog_urunler', params: { accountId: route.params.accountId } });

const gelenKutusuEkle = () =>
  router.push(`/app/accounts/${route.params.accountId}/settings/inboxes/new`);

onMounted(kataloglariYukle);
</script>

<template>
  <div class="p-6">
    <div v-if="yukleniyor" class="flex justify-center py-10">
      <Spinner />
    </div>

    <!-- Meta hesabi hic bagli degil -->
    <div
      v-else-if="!bagli"
      class="max-w-xl p-6 mx-auto text-center border rounded-lg border-n-weak bg-n-surface-1"
    >
      <span
        class="inline-flex items-center justify-center w-10 h-10 mb-3 rounded-full bg-n-alpha-1"
      >
        <span class="i-ri-facebook-circle-fill size-5 text-n-slate-11" />
      </span>
      <h2 class="mb-2 text-base font-medium text-n-slate-12">
        {{ t('KATALOG.META.HESAP_YOK_BASLIK') }}
      </h2>
      <p class="mb-4 text-sm text-n-slate-11">
        {{ t('KATALOG.META.HESAP_YOK') }}
      </p>
      <Button
        size="sm"
        variant="faded"
        icon="i-lucide-plus"
        :label="t('KATALOG.META.GELEN_KUTUSU_EKLE')"
        @click="gelenKutusuEkle"
      />
    </div>

    <div v-else class="flex flex-col gap-4">
      <!-- Izin hatasi: ham Meta mesaji ("This application has not been
           approved to use this api") kullaniciya ne yapacagini soylemiyor.
           Adimlari acikca yaziyoruz. -->
      <div
        v-if="izinHatasi"
        class="p-4 text-sm border rounded-lg border-n-weak bg-n-alpha-1"
      >
        <p class="mb-2 font-medium text-n-ruby-11">
          {{ t('KATALOG.META.IZIN_BASLIK') }}
        </p>
        <p class="mb-2 text-n-slate-11">{{ t('KATALOG.META.IZIN_ACIKLAMA') }}</p>
        <ol class="ml-4 list-decimal text-n-slate-11">
          <li>{{ t('KATALOG.META.IZIN_ADIM_1') }}</li>
          <li>{{ t('KATALOG.META.IZIN_ADIM_2') }}</li>
          <li>{{ t('KATALOG.META.IZIN_ADIM_3') }}</li>
        </ol>
        <p class="mt-2 text-xs text-n-slate-11">{{ hata }}</p>
      </div>
      <p v-else-if="hata" class="text-sm text-n-ruby-11">{{ hata }}</p>

      <!-- Bagli katalog -->
      <div
        v-if="secili"
        class="p-5 border rounded-lg border-n-weak bg-n-surface-1"
      >
        <div class="flex flex-wrap items-center gap-3">
          <span class="i-ri-facebook-circle-fill size-5 text-n-blue-11" />
          <div class="flex flex-col">
            <span class="text-sm font-medium text-n-slate-12">{{ secili.ad }}</span>
            <span class="text-xs text-n-slate-11">
              {{ secili.isletme }}
              <template v-if="secili.urun_sayisi != null">
                · {{ t('KATALOG.META.URUN_SAYISI', { sayi: secili.urun_sayisi }) }}
              </template>
            </span>
          </div>

          <div class="flex flex-wrap items-center gap-2 ml-auto">
            <a
              :href="commerceAdresi"
              target="_blank"
              rel="noopener noreferrer"
              class="inline-flex items-center gap-1 px-2 py-1 text-xs rounded text-n-slate-11 hover:text-n-slate-12 hover:bg-n-alpha-1"
            >
              <span class="i-lucide-external-link size-3.5" />
              {{ t('KATALOG.META.COMMERCE_AC') }}
            </a>
            <Button
              size="sm"
              variant="faded"
              icon="i-lucide-upload"
              :label="t('KATALOG.META.DISA_AKTAR')"
              :is-loading="disaAktariliyor"
              :disabled="mesgul"
              @click="disaAktar"
            />
            <Button
              size="sm"
              variant="faded"
              icon="i-lucide-unlink"
              :label="t('KATALOG.META.KALDIR')"
              :disabled="mesgul"
              @click="baglantiyiKaldir"
            />
          </div>
        </div>

        <p class="mt-3 text-sm text-n-slate-11">
          {{ t('KATALOG.META.BAGLI_ACIKLAMA') }}
        </p>
        <button
          type="button"
          class="mt-1 text-sm underline text-n-slate-11 hover:text-n-slate-12"
          @click="urunlereGit"
        >
          {{ t('KATALOG.META.URUNLERE_GIT') }}
        </button>

        <p v-if="sonuc" class="mt-2 text-sm text-n-teal-11">{{ sonuc }}</p>
      </div>

      <!-- Katalog secimi -->
      <div class="p-5 border rounded-lg border-n-weak bg-n-surface-1">
        <div class="flex items-start gap-3 mb-1">
          <h3 class="text-sm font-medium text-n-slate-12 grow">
            {{ secili ? t('KATALOG.META.DEGISTIR_BASLIK') : t('KATALOG.META.SEC_BASLIK') }}
          </h3>
          <!-- Katalog secili olmasa da Commerce Manager'a gidebilmeli:
               kullanici katalogunu orada olusturup buraya donuyor. -->
          <a
            :href="commerceAdresi"
            target="_blank"
            rel="noopener noreferrer"
            class="inline-flex items-center gap-1 text-xs shrink-0 text-n-slate-11 hover:text-n-slate-12"
          >
            <span class="i-lucide-external-link size-3.5" />
            {{ t('KATALOG.META.COMMERCE_AC') }}
          </a>
        </div>
        <p class="mb-3 text-sm text-n-slate-11">
          {{ t('KATALOG.META.SEC_ACIKLAMA') }}
        </p>

        <p v-if="!kataloglar.length" class="text-sm text-n-slate-11">
          {{ t('KATALOG.META.KATALOG_YOK') }}
          <a
            :href="commerceAdresi"
            target="_blank"
            rel="noopener noreferrer"
            class="underline"
          >
            {{ t('KATALOG.META.COMMERCE_AC') }}
          </a>
        </p>

        <div v-else class="flex flex-wrap items-end gap-2">
          <label class="text-sm text-n-slate-11">
            <span class="sr-only">{{ t('KATALOG.META.SEC_BASLIK') }}</span>
            <select v-model="seciliId" class="!mb-0 min-w-[280px]">
              <option value="">{{ t('KATALOG.META.SECINIZ') }}</option>
              <option v-for="k in kataloglar" :key="k.id" :value="String(k.id)">
                {{ k.ad }} — {{ k.isletme }}
                <template v-if="k.urun_sayisi != null">({{ k.urun_sayisi }})</template>
              </option>
            </select>
          </label>
          <Button
            size="sm"
            icon="i-lucide-link"
            :label="secili ? t('KATALOG.META.DEGISTIR') : t('KATALOG.META.BAGLA')"
            :is-loading="baglaniyor"
            :disabled="!seciliId || mesgul"
            @click="bagla"
          />
        </div>
      </div>

      <p v-if="atlananIce" class="text-sm text-n-slate-11">
        {{ t('KATALOG.META.ATLANAN_ICE', { sayi: atlananIce }) }}
      </p>

      <!-- Ice aktarilamayan urunler: sayi yetmez, hangi urun neden
           aktarilamadi yazmali ki kullanici duzeltebilsin. -->
      <div
        v-if="ayrintilar.length"
        class="p-4 text-sm border rounded-lg border-n-weak bg-n-surface-1"
      >
        <p class="mb-2 font-medium text-n-ruby-11">
          {{ t('KATALOG.META.ICE_AKTAR_HATALI', { sayi: ayrintilar.length }) }}
        </p>
        <ul class="ml-4 list-disc text-n-slate-11">
          <li v-for="(h, i) in ayrintilar" :key="i">
            <span class="text-n-slate-12">{{ h.urun }}</span> - {{ h.sebep }}
          </li>
        </ul>
      </div>

      <!-- Meta'nin zorunlu alanlari eksik oldugu icin gonderilemeyenler. -->
      <div
        v-if="atlananlar.length"
        class="p-4 text-sm border rounded-lg border-n-weak bg-n-surface-1"
      >
        <p class="mb-2 font-medium text-n-amber-11">
          {{ t('KATALOG.META.ATLANAN', { sayi: atlananlar.length }) }}
        </p>
        <ul class="ml-4 list-disc text-n-slate-11">
          <li v-for="(a, i) in atlananlar" :key="i">
            <span class="text-n-slate-12">{{ a.ad }}</span> -
            {{ t('KATALOG.META.EKSIK_ALANLAR', { alanlar: (a.eksikler || []).join(', ') }) }}
          </li>
        </ul>
      </div>

      <p v-if="secili?.senkron" class="text-xs text-n-slate-11">
        {{ t('KATALOG.META_ZAMAN', { zaman: zamanMetni(secili.senkron) }) }}
      </p>
    </div>
  </div>
</template>
